unable to read source [project]/node_modules/@zxing/src/readers/BrowserPDF417Reader.ts